import type { FC } from 'react'
import { HStack, VStack } from '@chakra-ui/react'
import { GrandText, ImageBox } from 'ui'
import { Currency, type ICartItemDetailSubItem } from 'ecosystem'
import { commaSeparator } from 'shared-utils'
import { getProductImages } from 'shared-utils/utils/products'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { useUIGlobalsContext } from 'ui/lib/ui-globals/hooks'

interface CartSubItemsProps {
  subItems?: ICartItemDetailSubItem[]
}

export interface CartSubItemsOverrides {
  currency?: string
}

const CheckoutCartSubItems: FC<CartSubItemsProps> = ({ subItems }) => {
  const overrides = useOverridesContext<keyof CartSubItemsOverrides>()
  const { priceMaximumFractionDigits } = useUIGlobalsContext()
  return (
    <VStack className="checkout-cart-item-subitems" w="full">
      {subItems?.map((subItem) => {
        const { mainImageUrl } = getProductImages(subItem.product.medias)
        return (
          <HStack key={subItem.product.id} p={2} px={10} w="full">
            <ImageBox
              alignSelf="flex-start"
              h={10}
              imageProps={{
                alt: subItem.product.name,
                title: subItem.product.name,
                src: mainImageUrl,
                style: {
                  objectFit: 'contain'
                },
                sizes: '5em'
              }}
              w={10}
            />
            <HStack w="full">
              <GrandText flexGrow={1} fontSize="sm">
                {subItem.product.name}
              </GrandText>
              <GrandText
                fontSize={{
                  base: 'xs',
                  md: 'sm'
                }}
                fontWeight="medium"
                textAlign="right"
              >
                {subItem.product.price
                  ? commaSeparator(subItem.product.price, priceMaximumFractionDigits)
                  : 0}{' '}
                {overrideText(Currency.SEK, overrides?.currency)}
              </GrandText>
            </HStack>
          </HStack>
        )
      })}
    </VStack>
  )
}

export default CheckoutCartSubItems
